import React, { Component } from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { APIClient } from '../../utils/APIClient';
import { API_URL } from '../../settings/local_settings';
import { ConfigureEventsStep } from '../client/ad_accounts/ConfigureEventsStep';
import { CHANNEL_INFO_BY_CHANNEL } from '../channels/channels';

// El nombre legible del canal («Facebook Ads»), el mismo que usa el aviso de Informes justo antes
// de abrir este modal. La constante cruda («FACEBOOK») se leía como un dato interno.
function channelLabel(channel) {
    const info = CHANNEL_INFO_BY_CHANNEL[channel];
    return (info && info.Spanish) || channel;
}


/**
 * Recorre las cuentas sin eventos de a una. `onComplete(savedCount)` y `toggle(savedCount)` reciben
 * cuántas cuentas se guardaron DE VERDAD: Informes sólo recalcula si hubo alguna (review
 * C-INFCONV-04). Los otros llamadores ignoran el argumento.
 */
class ConfigureEventsModalClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
        };
        // Contador y no state: se lee en el mismo tick en que se incrementa, al cerrar.
        this.savedCount = 0;
        this.handleSave = this.handleSave.bind(this);
        this.handleSkip = this.handleSkip.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.savedCount = 0;
            this.setState({ currentIndex: 0 });
        }
    }

    handleSave(selectedActions) {
        const { unconfiguredAccounts, t } = this.props;
        const account = unconfiguredAccounts[this.state.currentIndex];

        // Hasta el 24/09 avanzaba igual si el POST fallaba: el usuario creía haber configurado la
        // cuenta y los números seguían en cero sin explicación. Ahora lo dice, y la cuenta no cuenta
        // como guardada.
        const onError = () => toast.error(t('events_config_modal.save_error', {name: account.name,
            interpolation: {escapeValue: false}}));
        new APIClient(`${API_URL}client/ad_account/${account.id}/selected_actions`)
            .call('POST', { selected_actions: selectedActions })
            .then((response) => {
                if (response && response.status === 'OK') this.savedCount += 1;
                else onError();
                this.advanceToNext();
            })
            .catch(() => {
                onError();
                this.advanceToNext();
            });
    }

    handleSkip() {
        this.advanceToNext();
    }

    handleClose() {
        this.props.toggle(this.savedCount);
    }

    advanceToNext() {
        const { unconfiguredAccounts, onComplete } = this.props;
        const nextIndex = this.state.currentIndex + 1;

        if (nextIndex >= unconfiguredAccounts.length) {
            onComplete(this.savedCount);
        } else {
            this.setState({ currentIndex: nextIndex });
        }
    }

    render() {
        const { t, isOpen, unconfiguredAccounts } = this.props;
        const toggle = this.handleClose;
        const { currentIndex } = this.state;

        if (!unconfiguredAccounts || unconfiguredAccounts.length === 0) return null;

        const account = unconfiguredAccounts[currentIndex];
        const total = unconfiguredAccounts.length;

        return (
            // `scrollable`: con la lista de eventos larga, en una ventana baja el pie («Omitir» /
            // «Guardar eventos») quedaba cortado y había que scrollear para llegar a la acción
            // principal (QA `QA-VIS-infev-05`). Con esto scrollea el cuerpo y el pie queda fijo.
            <Modal isOpen={isOpen} toggle={toggle} size="lg" scrollable>
                <ModalHeader toggle={toggle}>
                    {t('events_config_modal.title')}
                    {total > 1 && (
                        <small className="text-muted" style={{ marginLeft: '0.5em', fontSize: '0.75em' }}>
                            ({t('events_config_modal.configuring_step', { current: currentIndex + 1, total })})
                        </small>
                    )}
                </ModalHeader>
                <div className="modal-section" style={{ padding: '0 2em' }}>
                    <p className="text-muted" style={{ marginBottom: '0.5em' }}>
                        {t('events_config_modal.description')}
                    </p>
                    <strong>
                        {t('events_config_modal.account_label', { name: account.name, channel: channelLabel(account.channel),
                            interpolation: { escapeValue: false } })}
                    </strong>
                </div>
                <ConfigureEventsStep
                    key={account.ad_account_db_id}
                    adAccountDbId={account.ad_account_db_id}
                    channel={account.channel}
                    onSave={this.handleSave}
                    onSkip={this.handleSkip}
                />
            </Modal>
        );
    }
}

export const ConfigureEventsModal = withTranslation()(ConfigureEventsModalClass);
export default ConfigureEventsModal;
